export default function TableHeader(props) {
  return(
    <thead>
      {props.children}
    </thead>
  );
};
